export const IS_MOBILE = /Mobi|Android|iPhone|iPad/.test(navigator.userAgent);

export const IS_SMALL_WIDTH = window.screen.width < 700;
